import router from "../router";
import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'

let user = JSON.parse(localStorage.getItem('user'));

let initialRole = user ? user.me.selected_company.role : "public"

Vue.use(AclInstaller)

export default new AclCreate({
  initial: initialRole,
  notfound: '/pages/error-404',
  router,
  acceptLocalRules: true,
  globalRules: {
    owner: new AclRule('owner').generate(),
    invited: new AclRule('invited').or('owner').generate(),
    public: new AclRule('public').or('invited').or('owner').generate()
  }
})
